import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "hidden",
  viewBox: "0 0 199 206"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"translate(-1792 -1284)\"><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"8\" stroke-width=\"20\" d=\"M1827 1465a17 17 0 0 1-17-17m164 0a17 17 0 0 1-17 17m.39 0h-130.4\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"8\" stroke-width=\"20\" d=\"M1810 1387v61.3m164-61.3v61.3\"></path><text font-family=\"Mulish, sans-serif\" font-size=\"59\" font-weight=\"900\" fill=\"currentColor\" transform=\"translate(1828.07 1438)\">PDF</text><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"8\" stroke-width=\"20\" d=\"M1892 1295v75.25m23.42-23.25-23.42 23.42m.45.03L1869 1347\"></path></g>", 1)
  ])))
}
export default { render: render }